import { render, staticRenderFns } from "./AppartmentRecapView.vue?vue&type=template&id=b32bca14&scoped=true&"
import script from "./AppartmentRecapView.vue?vue&type=script&lang=ts&"
export * from "./AppartmentRecapView.vue?vue&type=script&lang=ts&"
import style0 from "./AppartmentRecapView.vue?vue&type=style&index=0&id=b32bca14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32bca14",
  null
  
)

export default component.exports